
import store from 'frontend/store';

export const fractionalSizeOptions = {
	"0": 0,
	"1/8": 0.125,
	"1/4": 0.25,
	"3/8": 0.375,
	"1/2": 0.5,
	"5/8": 0.625,
	"3/4": 0.75,
	"7/8": 0.875,
};

export const fractionalSizeLabels = {
	0: "0",
	0.5: "1/2",
	0.25: "1/4",
	0.125: "1/8",
	0.75: "3/4",
	0.375: "3/8",
	0.625: "5/8",
	0.875: "7/8",
};

export const controlOptions = {
	standard: [
		{ text: 'Controls On Left', value: 'left', image: '/images/control-pos-left.png' },
		{ text: 'Controls On Right', value: 'right', image: '/images/control-pos-right.png' },
	],

	opera_roller: [
		{ text: 'Room Darkening LEFT / Screen RIGHT', value: 'room darkening left / screen right', image: '/images/control-pos-left.png' },
		{ text: 'Room darkening RIGHT / Screen LEFT', value: 'room darkening right / screen left', image: '/images/control-pos-right.png' },
	],

	opera_dual_zebra: [
		{ text: 'Room Darkening LEFT / Zebra RIGHT', value: 'room darkening left / zebra right', image: '/images/control-pos-left.png' },
		{ text: 'Room darkening RIGHT / Zebra LEFT', value: 'room darkening right / zebra left', image: '/images/control-pos-right.png' },
	],
};


export function canSelectOption(option, width, height, selected)
{
	var allOptions = store.state.customizer.options;
	var required = option.required_options.filter(id => allOptions[id]);

	// return false if not within the min/max size options
	if (option.restrict_to_size && (width < option.min_width || width >= option.max_width || height < option.min_height || height >= option.max_height))
		return false;

	// return false if this option requires other options to be selected
	if (required.length > 0)
	{
		// get intersection of selected and required options
		var found = required.filter(id => selected.includes(id));

		// if no intersection then return false;
		if (found.length == 0)
			return false;
	}

	return true;
}

// used to get the next-nearest-highest option when determining a product/option's price based on width/height
export function getSizeOption(size, options)
{
	var result = options[0]

	for(var value of options)
	{
		if (size <= value)
		{
			result = value;
			break;
		}
	}

	return result;
}



